<template>
  <img :src="'/assets/icons_' + $store.state.iconTheme + '/' + name" />
</template>
<script>
export default {
  props: ["name"]
};
</script>
